import { createClient } from '@supabase/supabase-js'

const supabaseUrl = "https://jkxwvuwzepyqfgalmtwe.supabase.co"
const supabaseKey = "sb_publishable_FH2vNTJBhYK2lHYvX-sHOQ_aR4-CjVh"

// Create a single instance of the client to use everywhere
export const supabase = createClient(supabaseUrl, supabaseKey)
export const MY_BACKEND_URL = "https://api-server-594443718691.asia-south1.run.app";
